export { TERMS_AND_CONDITIONS_MARKDOWN, PRIVACY_POLICY_MARKDOWN } from './content.generated'

/**
 * VERA-837 — @repo/legal exposes no machine-readable version/date for these
 * documents; the "Effective from January, 2026" line inside the Markdown is
 * prose, not a parseable field, and there is no doc-revision/content-hash
 * mechanism today. Acceptance records (see `user_legal_acceptances` in
 * apps/api) need SOME version string to record which revision of the terms
 * a user agreed to, so this is a hand-authored constant, colocated with the
 * content it versions rather than scattered as a magic string per call
 * site. Bump it whenever terms-and-conditions.md changes materially
 * (alongside regenerating content.generated.ts — see this package's
 * README). This is a real gap, not a long-term answer: a proper
 * doc-revision or content-hash field on @repo/legal would be more robust
 * than a human-remembered string, and re-versioning today does not
 * invalidate or re-surface consent for users who already accepted an
 * earlier version.
 */
export const TERMS_AND_CONDITIONS_VERSION = '2026-10-09'

/**
 * Live from 2026-10-09 on Spencer's go-ahead; counsel's open questions are in
 * ../PUBLICITY-CLAUSE-REVIEW.md.
 *
 * 2026-10-09 added the "Customer name and logo" paragraphs to section 9
 * (Intellectual Property): a business customer grants Vera a revocable right to
 * name it, with its logo, as a customer on Vera's websites and marketing.
 *
 * The FIRST terms version that carries that clause is
 * `PUBLICITY_CLAUSE_TERMS_VERSION` in @repo/types (packages/types/src/company/
 * website-display.ts), not here, because the API decides website eligibility
 * from it and the API cannot import this package (it consumes only built
 * `packages/*` with a dist; this one ships TS source). The API guard
 * `tests/unit/website-display.guard.spec.ts` reads this file and fails if
 * TERMS_AND_CONDITIONS_VERSION ever sorts BELOW that constant, or if the clause
 * disappears from terms-and-conditions.md while the constant still claims it.
 *
 * ⚠️ If counsel asks for a wording change, bump BOTH this version and
 * PUBLICITY_CLAUSE_TERMS_VERSION to the go-live date in the same commit.
 */
